import { render } from "./DashboardTV1.vue?vue&type=template&id=44ada5a1"
import script from "./DashboardTV1.vue?vue&type=script&lang=js"
export * from "./DashboardTV1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__